module.exports = __webpack_public_path__ + "media/images/emblems/La_Chaux-de-Fonds-coat_of_arms-54805105db8cd8ed3fa908ce8c9d5836.svg";